<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Edit Pinned Message</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/pinnedmsgs" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="updatePinnedMsg" v-if="pinnedMsg">
                <div class="row justify-content-md-center">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-12" v-if="corps.length">
                        <fg-select
                          v-model="pinnedMsg.corporationId"
                          label="Select Corporation"
                          :list="corps"
                          selectedKey="corporationId"
                          v-validate="rules.corporationId"
                          data-vv-name="Corproration"
                          cus-name="Corporation"
                          :has-errors="errors"
                          :is-fields="fields"
                        >
                        </fg-select>
                      </div>
                      <div class="col-12">
                        <fg-text-area type="text"
                                  v-model="pinnedMsg.corpAdminMessage"
                                  label="Pinned Message"
                                  placeholder="Enter Message"
                                  v-validate="rules.corpAdminMessage"
                                  data-vv-name="Pinned Message"
                                  cus-name="Pinned Message"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-text-area>
                      </div>
                      <div class="col-4">
                        <fg-input type="text"
                                  v-model="pinnedMsg.msgSenderName"
                                  label="Sender Name"
                                  placeholder="Enter Name"
                                  v-validate="rules.msgSenderName"
                                  data-vv-name="Sender Name"
                                  cus-name="Sender Name"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-4">
                        <label>Published Date</label>
                        <datetime v-model="publishDate"
                                  required
                                  input-class="form-control"
                                  label="Publish Date"
                                  placeholder="Select Date"
                                  type="date"
                                  input-format="DD-MM-YYYY"
                                  auto-continue>
                        </datetime>
                      </div>
                      <div class="col-4" v-if="status.length">
                        <fg-select
                          v-model="pinnedMsg.active"
                          label="Status"
                          v-validate="rules.active"
                          data-vv-name="active"
                          cus-name="active"
                          :has-errors="errors"
                          :is-fields="fields"
                          :list="status"
                          selectedKey="id"
                        >
                        </fg-select>
                      </div>
                    </div>
                  </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                            Update Pinned Message
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { imageHelpers } from '../../../../helpers/lambda'
    import moment from 'moment'
    export default {
        name: 'EditPinnedMsg',
        created (){
            this.fetchCorporations();
        this.$store.dispatch('GETSELECTEDPINNEDMSG', this.$route.params.id).then(() =>{
            this.pinnedMsg = this.selectedPinnedMsg;
            this.publishDate = new Date(this.pinnedMsg.msgSentDate).toISOString();
        })
    },
    data () {
        let dateTime = new Date();
        return {
            publishDate: dateTime.toISOString(),
            pinnedMsg: this.selectedPinnedMsg || {},
            corps: [],
          rules: {
            msgSenderName: {required : true},
            corpAdminMessage: {required : true},
            active: {required: true}
          },
          status: [{name:'Select Status'}, {id:"1", name:'Active'}, {id:"0", name:'Inactive'}]
        }
    },
    methods: {
      fetchCorporations () {
        this.$store.dispatch('FETCH_CORPORATIONS')
          .then((res) => {
            this.corps = res;
            console.log("this.corporations : ", this.corps);
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
        updatePinnedMsg () {
          this.pinnedMsg.msgSentDate =  moment(this.publishDate).format('YYYY-MM-DD');
          this.$validator.validateAll().then((result) => {
            if(result){
              let updatePinnedMsg = () =>{
                this.$store.dispatch('UPDATE_PINNEDMSG', this.pinnedMsg)
                  .then((res) => {
                    console.log("msgSenderName: ", res);
                    this.showPopup('Success!', 'Pinned Message is successfully updated', 'success', ()=>this.$router.push('/admin/pinnedmsgs'))

                  })
                  .catch(err => {
                    this.showPopup('Error!', 'some thing happen wrong', 'error')
                    console.log("UPDATE_PINNEDMSG API error : ", err);
                  })
              };
              updatePinnedMsg();
            }
          },
           (error) => {
              console.log('error ', error)
          });
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    },
    computed: {...mapGetters([
        'pinnedMsgs', 'selectedPinnedMsg']) }
    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PinnedMsgs/EditPinnedMsg.vue